













































































































































import {
  FormFieldType,
  Field,
} from '~/workera/utils/typedForms/shared/form/FormField'
import { FormDescription } from '~/workera/utils/typedForms/shared/form/FormDescription'
import { ValidatorResponse } from '~/utils/typedForms/validators/common/ValidatorResponse'
import { Option, Some } from 'space-lift'
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator'
import { boolean } from 'space-lift/commonjs/object/is'
import { ModifierResponse } from '../../utils/typedForms/modifiers/common/ModifierResponse'
import Multiselect from 'vue-multiselect'

@Component({
  components: {
    Multiselect,
  },
})
export default class TypedGeneralFormFields extends Vue {
  @PropSync('form', FormDescription) readonly syncedForm!: FormDescription
  @PropSync('editable', { type: Boolean }) syncedEditable!: Boolean
  @PropSync('value', { type: Object }) syncedValue!: Object

  FormFieldType = FormFieldType
  loaded = false

  mounted() {
    const questionFields = this.syncedForm.fields
    for (let index in questionFields) {
      this.updateValue(questionFields[index], true)
    }
  }

  updateValueWithEvent(event: Event, field: Field) {
    const modifier: ModifierResponse = field.modify(Some(event))
    const validation: ValidatorResponse = field.validate(modifier.result)
    this.updateValueWrapper(field, modifier, validation)
  }

  updateValue(field: Field, isFirstValidation: Boolean) {
    const modifier: ModifierResponse = field.modify()
    const validation: ValidatorResponse = field.validate()
    this.updateValueWrapper(field, modifier, validation, isFirstValidation)
  }

  updateValueWrapper(
    field: Field,
    modifier: ModifierResponse,
    validation: ValidatorResponse,
    isFirstValidation: Boolean = false
  ): Void {
    if (!isFirstValidation && !validation.isSuccess()) {
      field.validationError = validation.message
    }

    this.syncedValue[field.key] = modifier.result
    field.value = this.syncedValue[field.key]
    this.loaded = true
    this.$emit('input', this.syncedValue)
  }

  filterValidationErrors(error: String[]) {
    return error ? error.filter(e => e.length) : []
  }

  @Watch('computedSyncedValue')
  onSyncedValueChanged(newSyncedValue: Object, oldSyncedValue: Object) {
    const properties: string[] = Object.getOwnPropertyNames(
      newSyncedValue
    ).filter(v => v !== '__ob__')

    properties.forEach(propertyName => {
      const questionField = this.computedQuestionFields.find(
        field => field.key === propertyName
      )
      if (questionField) {
        questionField.value = newSyncedValue[propertyName]
      }
    })
  }

  get computedQuestionFields() {
    return this.syncedForm.fields
  }

  get computedSyncedValue() {
    return this.syncedValue
  }

  isGeneralInputField(field: Field) {
    return [
      FormFieldType.TELEPHONE,
      FormFieldType.PASSWORD,
      FormFieldType.INPUT,
    ].includes(field.fieldType)
  }

  showIcon(field: Field) {
    return field.icon && field.icon.isDefined()
  }

  sharedRow(field: Field) {
    if (field.sharedRow && field.marginRight)
      return 'shared-row row-margin-right'
    else if (field.sharedRow) return 'shared-row'
    else return ''
  }
}
